import { BehaviorSubject } from 'rxjs';
import { useState, useEffect } from 'react';

export function formatLayout({ collapseSidebar } = {}) {
    return {
        collapseSidebar: !!collapseSidebar,
    };
}

// This subject is a way to adjust the layout of the app at the top level --
// specifically the state of the sidebar by default, etc.
export const alliLayout = new BehaviorSubject(formatLayout());

// Should a microfrontend need to view the current layout
export function useAlliLayout() {
    const [layout, setLayout] = useState(alliLayout.getValue());

    useEffect(() => {
        const observer = alliLayout.subscribe(layout => setLayout(layout));
        return () => observer.unsubscribe();
    }, [setLayout]);

    return layout;
}

export function setAlliLayout(layout = {}) {
    alliLayout.next(formatLayout(layout));
}
